/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import { max } from 'd3-array'
import { geoPath } from 'd3-geo'
import { contourDensity } from 'd3-contour'
import { polygonContains } from 'd3-polygon'
import last from 'lodash/last'
import ContourLegend from '../../Legend/ContourLegend'

export default function Contour({ settings, chartOptions = {} }) {
    const pitchData = settings.data

    const pitcherView = chartOptions.pitcherPerspective

    const x = scaleLinear()
        .range([0, settings.vizWidth])
        .domain(pitcherView ? [4, -4] : [-4, 4])

    let y = scaleLinear().range([settings.vizHeight, 0]).domain([-1, 6])

    if (chartOptions.strikeZone === 'relative') {
        y = scaleLinear().range([settings.vizHeight, 0]).domain([-4, 4])
    }

    const density = contourDensity()
        .x((d) => x(d.x))
        .y((d) => y(d.y))
        .thresholds(9)
        .size([settings.vizWidth, settings.vizHeight])
        .bandwidth(8)(pitchData)

    // Use this to calculate legend max density
    density.forEach((d) => {
        d.count = 0
        d.coordinates.forEach((poly) => {
            pitchData.forEach((p) => {
                const px = x(p.x)
                const py = y(p.y)
                if (polygonContains(poly[0], [px, py])) {
                    d.count += 1
                }
            })
        })
    })

    if (!density.length) {
        return null
    }

    const maxCount = last(density)?.count
    const maxValue = max(density, (d) => d.value)

    const colorDensity = scaleLinear()
        .range(['#3661AD', '#ffffff', '#D82129'])
        .domain([0, maxValue / 2, maxValue])

    const path = geoPath()

    return (
        <>
            <g key="contourChart" id="contourChart">
                {density.map((d, i) => {
                    const stroke = 'none'

                    return (
                        <path
                            // eslint-disable-next-line react/no-array-index-key
                            key={`contour_${i}`}
                            stroke={stroke}
                            d={path(d)}
                            fill={colorDensity(d.value)}
                            opacity={chartOptions.opacity}
                        />
                    )
                })}
            </g>
            {chartOptions.legend ? (
                <ContourLegend
                    settings={settings}
                    maxCount={maxCount}
                    opacity={chartOptions.opacity}
                />
            ) : null}
        </>
    )
}
